var React = require('react');
var ReactNative = require('react-native');

import Icon from './wrappers/ReUpIcon';

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var QRCodeView = require('./QRCodeView.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var NetworkManager = require('./NetworkManager.js');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKSpinner
} = MK;

var {
  AppRegistry,
  StyleSheet,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
} = ReactNative;

function getBase64Data(data)
{
  var dataJsonString = JSON.stringify(data);
  var dataBase64 = btoa(dataJsonString);

  return dataBase64;
}

var testData = [
            {
                "PassID": "1",
                "Name": "Facials",
                "Description": "Get 5 facials for the price of 4!",
                "RedeemQuantity": "5",
                "Cost": "100.00",
                "TaxRate": "0.13",
                "IsDisabled": "0",
                "IsDeleted": "0",
                "PassBlob": "{\"StartDate\": \"\", \"EndDate\": \"\", \"LimitPerCustomer\": \"\", \"PurchaseWithCredit\": \"\"}",
                "AmountCharged": "113.00"
            },
            {
                "PassID": "2",
                "Name": "Manicures",
                "Description": "Get 10 manicures for $200!",
                "RedeemQuantity": "10",
                "Cost": "200.00",
                "TaxRate": "0.13",
                "IsDisabled": "0",
                "IsDeleted": "0",
                "PassBlob": "{\"StartDate\": \"\", \"EndDate\": \"\", \"LimitPerCustomer\": \"\", \"PurchaseWithCredit\": \"\"}",
                "AmountCharged": "226.00",
                "StateEnum": "1",
                "RedeemQuantityRemaining": "6"
            },
            {
                "PassID": "3",
                "Name": "Unlimited Blows",
                "Description": "Subscribe now and get unlimited blows for $30 per month!",
                "RedeemQuantity": "10",
                "Cost": "30.00",
                "TaxRate": "0.13",
                "IsDisabled": "0",
                "IsDeleted": "0",
                "PassBlob": "{\"type\": \"1\"}",
                "AmountCharged": "33.90",
            }
        ]

var UsePass = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      pass : this.props.extras.pass,
    }
  },

  componentDidMount : function()
  {
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;

    NetworkManager.update(appManager, ['Users'], function()
    {
      // success
    }, function(result)
    {
      appActions.checkErrorCodeAndReturnIfHandled(result.code)
    }, function(data)
    {
      appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
    });

    this._hash = appManager.currentUser()[ModelConstants.Hash];
    this.queuePoll();
  },

  componentWillUnmount : function()
  {
    if( this._pollTimeout != null ) clearTimeout(this._pollTimeout);
  },

  _pollTimeout : null,
  queuePoll : function()
  {
    var appManager = this.props.appManager;
    var thisThing = this;
    this._pollTimeout = setTimeout(()=>
    {
      if( appManager.isLoggedIn() )
      {
        NetworkManager.update( appManager, ["Passes", "User"], (data)=>
        {
          if( typeof data["Users"] !== 'undefined' && data["Users"].length > 0 )
          {
            var user = data["Users"][0];
            if( typeof user !== 'undefined' && user != null && typeof user[ModelConstants.Hash] !== 'undefined' )
            {
              var newHash = user[ModelConstants.Hash];
              if( newHash != thisThing._hash )
              {
                appManager.setCurrentUser(user, ()=>
                {
                  thisThing._hash = newHash;
                  thisThing.forceUpdate();
                });
              }
            }
          }

          var passes = data["Passes"];
          if( typeof passes !== 'undefined' && passes != null && passes.length > 0 )
          {
            for( var i = 0; i < passes.length; i++ )
            {
              if( passes[i].PassID == thisThing.props.extras.pass.PassID )
              {
                if( JSON.stringify(passes[i]) != JSON.stringify(thisThing.state.pass) )
                {
                  appManager.setData({Passes:passes});
                  thisThing.setState({pass:passes[i]});
                }
                break;
              }
            }
          }
          thisThing.queuePoll();
        }, ()=>
        {
          thisThing.queuePoll();
        })
      }
      else
      {
        thisThing.queuePoll();
      }
    }, 5000);
  },

  didUpdate : function()
  {
    var thisThing = this;
    this.props.appManager.getDataType("Passes", (data) =>
    {
      // data = testData;
      if( data == null ) return;

      for( var i = 0; i < data.length; i++ )
      {
        if( data[i].PassID == thisThing.props.extras.pass.PassID )
        {
          thisThing.setState({pass:data[i]});
          break;
        }
      }
    })
  },

  render: function()
  {
    var thisPass = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();
    var pass = this.state.pass;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
    var tipStatement = locManager.localizedStringForKey("TIP_PERCENTAGE_LABEL");

    var dimension = Math.min(this.state.layout.width-100, this.state.layout.height-164);

    var qrData = {};
    qrData["AppID"] = appManager.getAppInfo()["appid"];
    qrData["Type"] = "pass";
    qrData["U"] = user[ModelConstants.UserID];
    qrData["H"] = user[ModelConstants.Hash];
    qrData["P"] = pass.PassID;

    var qrDataBase64 = getBase64Data(qrData);
    var passName = pass.Name;
    var instructions = (typeof pass.RedeemQuantityRemaining === 'undefined' ? "0" : pass.RedeemQuantityRemaining) + "/" + pass.RedeemQuantity + " " + passName + " remaining";

    return (
      <View style={styles.container}
        onLayout={(event)=>this.setState({layout:event.nativeEvent.layout})}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor: generalColor}]} />

        <ReUpScrollView bounces={true} responder={this}>
          <View style={[styles.instructionContainer, {backgroundColor:instructionColor, color:instructionTitleColor}]}>
            <View style={{flex:1, alignSelf:'center'}}>
              <ReUpText appManager={appManager} style={[styles.instructionText, {numberOfLines:3, color:instructionTitleColor}]}>
              {instructions}
              </ReUpText>
            </View>
            <View style={{width:50}}>
              <ReUpIconButton type={3}
                appManager={appManager}
                featureData={this.props.featureData}
                appActions={this.props.appActions}
                locParams={[passName]}
              />
            </View>
          </View>
          <ShadowView appManager={appManager} layout={this.state.layout} />
          <QRCodeView key="qrcode" data={qrDataBase64} dimension={dimension} style={styles.qrcode} spinnerView={<MKSpinner style={{alignSelf : 'center',backgroundColor : 'transparent'}} strokeColor={[generalTitleColor]} />} />
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    backgroundColor:'blue',
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  qrcode: {
    padding: 30,
    alignItems:'center',
  }
});

UsePass.dataDependencies = ["Passes"]

module.exports = UsePass;



// WEBPACK FOOTER //
// ./src/UsePass.js